import React, { useState, useEffect } from 'react';
import productData from '../../data/product.json';
import {
  Overlay,
  Content,
  CloseButton,
  FrameImage,
  ProductsSection,
  SectionTitle,
  ProductCard,
  ProductImage,
  ProductInfo,
  ProductTitle,
  ProductPrice,
  ProductLink,
  QRColumn,
  QRImage,
  Spinner,
  EmptyMessage,
} from './styles/product-frame-popup';

export default function ProductFramePopup({ isOpen, onClose, frame, videoSlug }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Hàm generate QR code từ URL
  const generateQRCode = (url) => {
    const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(url)}`;
    return qrApiUrl;
  };

  // Format timestamp to mm:ss
  const formatTimestamp = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  };

  // Fetch products when popup opens
  useEffect(() => {
    if (!isOpen || !frame?.timestamp) {
      setProducts([]);
      setError(null);
      return;
    }

    const loadProducts = () => {
      setLoading(true);
      setError(null);

      try {
        // --- API call đã được comment lại, dùng local JSON thay thế ---
        // const apiUrl = process.env.API_GET_CLOTHES || 'https://vieon.farmcode.io.vn/analyze/url';
        // const response = await fetch(apiUrl, {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({ image_url: frame.thumbnail, k_per_item: 2 }),
        // });
        // if (!response.ok) throw new Error('Failed to fetch products');
        // const data = await response.json();

        // Lookup từ product.json theo video slug + timestamp
        const videoEntry = productData.find((entry) => entry.video === videoSlug);
        const matchedProducts = videoEntry ? videoEntry.product.filter((p) => p.timestamp === frame.timestamp) : [];

        const extractedProducts = matchedProducts.map((p) => ({
          id: p.sku,
          sku: p.sku,
          title: p.title,
          category: p.category,
          color: p.color,
          price: p.price,
          image: p.image_url,
          product_url: p.product_url,
          slot: p.slot,
        }));

        setProducts(extractedProducts);
      } catch (err) {
        console.error('Error getting products:', err);
        setError('Không thể tải sản phẩm');
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [isOpen, frame, videoSlug]);

  if (!isOpen || !frame) return null;

  return (
    <Overlay onClick={onClose}>
      <Content onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>✕</CloseButton>

        <div style={{ display: 'flex', gap: '30px', width: '100%' }}>
          {/* Left side - Frame Image */}
          <div style={{ flex: '0 0 500px' }}>
            <FrameImage src={frame.thumbnail} alt={`Frame at ${formatTimestamp(frame.timestamp)}`} />
            <div
              style={{
                color: 'white',
                fontSize: '16px',
                marginTop: '15px',
                textAlign: 'center',
                fontWeight: '500',
              }}
            >
              Khung hình tại: <span style={{ color: '#15D71B' }}>{formatTimestamp(frame.timestamp)}</span>
            </div>
          </div>

          {/* Right side - Products */}
          <ProductsSection>
            <SectionTitle>Sản phẩm trong khung hình</SectionTitle>

            {loading && (
              <div
                style={{
                  color: 'white',
                  textAlign: 'center',
                  padding: '40px 20px',
                  fontSize: '14px',
                }}
              >
                <Spinner />
                <div style={{ marginTop: '15px' }}>Đang phân tích trang phục...</div>
              </div>
            )}

            {error && <EmptyMessage style={{ color: '#ff6b6b' }}>{error}</EmptyMessage>}

            {!loading && !error && products.length === 0 && (
              <EmptyMessage>Không tìm thấy sản phẩm phù hợp</EmptyMessage>
            )}

            {!loading &&
              products.map((product) => (
                <ProductCard key={product.id}>
                  <ProductImage src={product.image} alt={product.title} />
                  <ProductInfo>
                    <ProductTitle>{product.title}</ProductTitle>
                    <ProductPrice>
                      {new Intl.NumberFormat('vi-VN', {
                        style: 'currency',
                        currency: 'VND',
                      }).format(product.price)}
                    </ProductPrice>
                    <ProductLink href={product.product_url} target="_blank" rel="noopener noreferrer">
                      Xem sản phẩm
                    </ProductLink>
                  </ProductInfo>
                  <QRColumn>
                    <QRImage src={generateQRCode(product.product_url)} alt="QR Code" />
                  </QRColumn>
                </ProductCard>
              ))}
          </ProductsSection>
        </div>
      </Content>
    </Overlay>
  );
}
